const Vue = require('vue');

Vue.component('ui-page-title', {
    props: {
        title: {
            type: String
        },
        icon: {
            type: String
        },
        description: {
            type: String
        }
    },
    methods: {},
    data() {
        return {};
    },
    ready() {},
    template: `
        <div class="clearfix">
            <h3 class="page-title pull-left" style="width: 100%">
                <i v-if="icon" v-bind:class="icon"></i>
                {{ title }}
                
                <small>{{ description }}</small>
        
                <div class="pull-right">
                    <slot></slot>
                </div>
            </h3>
        </div>    
    `
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui/page-title.js